import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function TestimonialRender({ node }) {
  const content = node.content || {};
  
  const quote = content.quote || 'Der Support und die Plattform sind absolut erstklassig. Seit wir das CMS nutzen, sparen wir jeden Tag 2 Stunden Arbeitszeit!';
  const authorName = content.authorName || 'Max Mustermann';
  const authorRole = content.authorRole || 'Store Manager, Berlin';
  const avatarUrl = content.avatarUrl || 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?q=80&w=200&auto=format&fit=crop';
  
  return (
    <div style={{
      background: 'rgba(255,255,255,0.03)',
      border: '1px solid rgba(255,255,255,0.05)',
      borderRadius: '16px',
      padding: '32px',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    }}>
      {/* Stars */}
      <div style={{ color: '#fbbf24', fontSize: '20px', letterSpacing: '4px' }}>★★★★★</div>
      
      {/* Quote */}
      <p style={{
        margin: 0,
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#e2e8f0',
        fontStyle: 'italic'
      }}>
        "{quote}"
      </p>

      {/* Author */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginTop: 'auto' }}>
        <img 
          src={avatarUrl} 
          alt={authorName}
          style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(255,255,255,0.1)' }}
        />
        <div>
          <div style={{ fontWeight: 'bold', color: '#fff', fontSize: '15px' }}>{authorName}</div>
          <div style={{ color: '#94a3b8', fontSize: '13px' }}>{authorRole}</div>
        </div>
      </div>
    </div>
  );
}

registry.register('Testimonial', {
  label: 'Kundenstimme',
  icon: '💬', 
  category: 'advanced',
  component: TestimonialRender,
  
  defaultProps: {
    content: {
      quote: 'Der Service und die Zuverlässigkeit des O2 Netzes sind einfach unfassbar gut geworden. Absolute Empfehlung für jeden Business-Kunden.',
      authorName: 'Erika Musterfrau',
      authorRole: 'CEO, Tech Startup',
      avatarUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop'
    },
    style: {
      desktop: {
        width: '100%',
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Zitat',
          fields: [
            { name: 'content.quote', label: 'Aussage', type: 'textarea' }
          ]
        },
        {
          title: 'Autor',
          fields: [
            { name: 'content.authorName', label: 'Name', type: 'text' },
            { name: 'content.authorRole', label: 'Titel / Rolle', type: 'text' },
            { name: 'content.avatarUrl', label: 'Avatar Bild (URL)', type: 'text' }
          ]
        }
      ]
    }
  ]
});
